/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LaundryGroupSubscriptionUpdateServicePackagePlanOptions } from './LaundryGroupSubscriptionUpdateServicePackagePlanOptions';
import {
    LaundryGroupSubscriptionUpdateServicePackagePlanOptionsFromJSON,
    LaundryGroupSubscriptionUpdateServicePackagePlanOptionsFromJSONTyped,
    LaundryGroupSubscriptionUpdateServicePackagePlanOptionsToJSON,
} from './LaundryGroupSubscriptionUpdateServicePackagePlanOptions';
import type { ServicePackagePlanReference } from './ServicePackagePlanReference';
import {
    ServicePackagePlanReferenceFromJSON,
    ServicePackagePlanReferenceFromJSONTyped,
    ServicePackagePlanReferenceToJSON,
} from './ServicePackagePlanReference';

/**
 * 
 * @export
 * @interface LaundryGroupSubscriptionUpdate
 */
export interface LaundryGroupSubscriptionUpdate {
    /**
     * 
     * @type {ServicePackagePlanReference}
     * @memberof LaundryGroupSubscriptionUpdate
     */
    activatedServicePackagePlan: ServicePackagePlanReference;
    /**
     * 
     * @type {Array<LaundryGroupSubscriptionUpdateServicePackagePlanOptions>}
     * @memberof LaundryGroupSubscriptionUpdate
     */
    servicePackagePlanOptions?: Array<LaundryGroupSubscriptionUpdateServicePackagePlanOptions>;
}

/**
 * Check if a given object implements the LaundryGroupSubscriptionUpdate interface.
 */
export function instanceOfLaundryGroupSubscriptionUpdate(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "activatedServicePackagePlan" in value;

    return isInstance;
}

export function LaundryGroupSubscriptionUpdateFromJSON(json: any): LaundryGroupSubscriptionUpdate {
    return LaundryGroupSubscriptionUpdateFromJSONTyped(json, false);
}

export function LaundryGroupSubscriptionUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): LaundryGroupSubscriptionUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'activatedServicePackagePlan': ServicePackagePlanReferenceFromJSON(json['activatedServicePackagePlan']),
        'servicePackagePlanOptions': !exists(json, 'servicePackagePlanOptions') ? undefined : ((json['servicePackagePlanOptions'] as Array<any>).map(LaundryGroupSubscriptionUpdateServicePackagePlanOptionsFromJSON)),
    };
}

export function LaundryGroupSubscriptionUpdateToJSON(value?: LaundryGroupSubscriptionUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'activatedServicePackagePlan': ServicePackagePlanReferenceToJSON(value.activatedServicePackagePlan),
        'servicePackagePlanOptions': value.servicePackagePlanOptions === undefined ? undefined : ((value.servicePackagePlanOptions as Array<any>).map(LaundryGroupSubscriptionUpdateServicePackagePlanOptionsToJSON)),
    };
}

